import { stats } from '../data';

const heroBg =
  'https://readdy.ai/api/search-image?query=soft%20abstract%20watermelon%20inspired%20background%20with%20warm%20cream%20texture%2C%20gentle%20coral%20red%20ripples%20and%20fresh%20green%20organic%20shapes%2C%20juicy%20gradient%20translucency%2C%20calm%2C%20airy%2C%20high%20brightness%20editorial%20art%2C%20no%20text&width=1920&height=1080&seq=navi-hero-x1&orientation=landscape';

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[620px] md:min-h-[660px] w-full items-center overflow-hidden bg-background-50">
      <img src={heroBg} alt="导航吃瓜首页横幅背景" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/60 to-background-50/95" aria-hidden="true"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <nav aria-label="面包屑" className="mb-5 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
            <span className="rounded-full bg-background-50/80 px-3 py-1 ring-1 ring-background-200">导航吃瓜</span>
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
            <span className="rounded-full bg-background-50/80 px-3 py-1 text-primary-700 ring-1 ring-primary-200">首页索引</span>
          </nav>

          <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-medium text-accent-800">
            <i className="ri-fire-line" aria-hidden="true"></i>
            今日已更新话题 86 条 · 持续收录中
          </p>

          <h1 className="font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            全网吃瓜话题，
            <span className="text-primary-600">分类索引一目了然</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            导航吃瓜把散落在影视、综艺、明星、网红与直播等方向的内容，按<span className="font-semibold text-foreground-800">分类、标签、专题、板块、栏目、目录</span>重新编排。
            告别大海捞针，先定位感兴趣的吃瓜方向，再一键直达。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#category"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-grid-fill" aria-hidden="true"></i>浏览分类导航
            </a>
            <a
              href="#topic"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/90 px-7 py-3.5 text-sm font-semibold text-foreground-800 ring-1 ring-background-300 transition hover:bg-background-100"
            >
              <i className="ri-folder-open-fill" aria-hidden="true"></i>查看精品专题
            </a>
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-200/80 bg-background-50/85 px-5 py-4 backdrop-blur-sm"
            >
              <dd className="font-display text-2xl text-accent-600 md:text-3xl">{s.value}</dd>
              <dt className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}